import { Routes } from '@angular/router';

export const routes: Routes = [
    { path: 'stars-internal', loadChildren: () => import('../stars/stars-internal/stars-internal.module').then(m => m.StarsInternalModule)},
    { path: 'air-services', loadChildren: () => import('../stars/stars-external/stars-external.module').then(m => m.StarsExternalModule)}
];
